// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLineNotesStyles } from "@conklin/Overrides/Widgets/Cart/CartLineNotes";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

cartLineNotesStyles.label = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.bold,
    color: "common.ui9",
    css: css`
        display: flex;
        cursor: pointer;
        align-items: center;
        width: max-content;
        ${IconWrapper} {
            opacity: 0.5;
            margin-right: 6px;
            &,
            & svg {
                height: auto;
            }
        }

        &:hover {
            &,
            & ${IconWrapper} {
                color: ${color("common.ui10")};
            }
        }
        @media print {
            display: none;
        }
    `,
};

cartLineNotesStyles.editableNotesTextArea = {
    cssOverrides: {
        formField: css`
            margin-top: 8px;
        `,
        inputSelect: css`
            resize: vertical;
        `,
    },
    css: css`
        @media print {
            background: none;
            resize: none;
        }
    `,
};

cartLineNotesStyles.nonEditableNotesTextArea = {
    css: css`
        &&& {
            resize: none;
            max-width: 100%;
            opacity: 1;
            border-color: ${color("common.ui5", 0.33)};
            @media print {
                background: none;
            }
        }
    `,
};
